// ====================================================
// VidyaTrack – Firebase Configuration
// Project: vidyatrack3
//
// TWO app instances:
//   app         → main session  (the logged-in user)
//   secondaryApp → used ONLY for creating new accounts
//                  so it never disturbs the Admin session
// ====================================================

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey            : "AIzaSyDvqTVVYgh9KcCJTu8mWg4CJR81C8A9Dgk",
  authDomain        : "vidyatrack3.firebaseapp.com",
  databaseURL       : "https://vidyatrack3-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId         : "vidyatrack3",
  storageBucket     : "vidyatrack3.firebasestorage.app",
  messagingSenderId : "800260248415",
  appId             : "1:800260248415:web:ef8ed4551c80e35e511cea",
  measurementId     : "G-63EG36BVD8",
};

// ── Primary app  (manages the Admin/Teacher/Student/Parent session) ──
const app = initializeApp(firebaseConfig, "primary");

// ── Secondary app (used ONLY to create new user accounts)
//    Firebase automatically signs in after createUserWithEmailAndPassword.
//    By using a separate app instance, that auto-login happens here
//    and is immediately signed out, leaving the Admin session untouched.
const secondaryApp = initializeApp(firebaseConfig, "secondary");

export const auth          = getAuth(app);           // primary auth
export const secondaryAuth = getAuth(secondaryApp);  // for account creation
export const db            = getFirestore(app);
export const rtdb          = getDatabase(app);

// Analytics – browser only
isSupported().then(yes => { if (yes) getAnalytics(app); });

export default app;
